import { z } from 'zod';
import { $CandidateDecisionType } from './CandidateDecisionType';
import { $CandidatePhoto } from './CandidatePhoto';
import { $CandidateResumeRelation } from './CandidateResume';
import { $CandidateStatusCode } from './candidateStatus';
import { $CandidateVacancy } from './CandidateVacancy';

const $CandidateEducationLevel = z.object({
  id: z.number(),
  name: z.string().nullable(),
  code: z.string().nullable(),
  professionName: z.string(),
});

export const $Candidate = z.object({
  id: z.number(),
  candidateVacancyId: z.number().nullable(),
  phone: z.string(),
  status: $CandidateStatusCode,
  firstName: z.string(),
  lastName: z.string(),
  age: z.number(),
  cityIds: z.array(z.number()),
  allCities: z.boolean(),
  educationLevel: $CandidateEducationLevel.nullable(),
  professionName: z.string().nullable(),
  birthAt: z.string().nullable(),
  preferredCommunicationLanguage: z.string(),
  interviewRequired: z.boolean(),
  latitude: z.number(),
  longitude: z.number(),
  pingEnabled: z.boolean(),
  createdAt: z.string(),
  updatedAt: z.string(),
  rating: z.number().nullable(),
  generalInfo: z.string().nullable(),
  matchPercent: z.number(),
  matchReason: z.string().nullable(),
  candidateVacancyStatus: z.string(),
  decisionType: $CandidateDecisionType,
  summary: z.string(),
  analysis: z.string(),
  candidateVacancyCreatedAt: z.string(),
  resumes: z.array($CandidateResumeRelation),
  vacancies: z.array($CandidateVacancy),
  photo: $CandidatePhoto.nullable(),
});
